module.exports = __webpack_public_path__ + "static/img/8-01.cd58c3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/8-01.png
// module id = 182
// module chunks = 1